function toFiniteNumber(value) {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string" && value.trim() !== "") {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) return parsed;
  }
  return null;
}

/**
 * Coerce a passenger field that may be a number or a nested
 * { adults, infants, minors, seniors } object from Firebase.
 */
export function toPassengerCount(value, key) {
  const direct = toFiniteNumber(value);
  if (direct != null) return direct;

  if (value == null || typeof value !== "object" || Array.isArray(value)) {
    return 0;
  }

  const nested = key ? value[key] : undefined;
  if (nested != null && nested !== value) {
    const fromKey = toPassengerCount(nested, key);
    if (key !== "total") return fromKey;
    if (fromKey) return fromKey;
  }

  if (key === "total" || key == null) {
    const explicit = toFiniteNumber(value.total);
    if (explicit != null) return explicit;
    return (
      toPassengerCount(value.adults, "adults") +
      toPassengerCount(value.seniors, "seniors") +
      toPassengerCount(
        value.minors != null ? value.minors : value.children,
        value.minors != null ? "minors" : "children"
      ) +
      toPassengerCount(value.infants, "infants")
    );
  }

  return 0;
}

export function getPassengerCounts(source) {
  if (!source || typeof source !== "object") {
    return {
      adults: 0,
      seniors: 0,
      minors: 0,
      infants: 0,
      children: 0,
      total: 0,
    };
  }

  const adults = toPassengerCount(source.adults, "adults");
  const seniors = toPassengerCount(source.seniors, "seniors");
  const minors = toPassengerCount(
    source.minors != null ? source.minors : source.children,
    source.minors != null ? "minors" : "children"
  );
  const infants = toPassengerCount(source.infants, "infants");
  const summed = adults + seniors + minors + infants;
  const totalFromField =
    source.total != null ? toPassengerCount(source.total, "total") : 0;

  return {
    adults,
    seniors,
    minors,
    infants,
    children: minors,
    // Inquiry sometimes stores total: 1 with adults: 2. Prefer the larger count.
    total: Math.max(totalFromField, summed),
  };
}

export function formatPassengerSummary(source) {
  const pax = getPassengerCounts(source);
  return `${pax.total} (${pax.adults} Adults, ${pax.children} Children/Minors, ${pax.infants} Infants, ${pax.seniors} Seniors)`;
}
